import { buildDemoCommunicationNetworkGraphLinkInspectorResponse } from '@web/lib/demo/communicationNetworkGraph/linkInspectorMocks';
export var communicationNetworkGraphLinkInspector = function (input) {
    return buildDemoCommunicationNetworkGraphLinkInspectorResponse(input);
};
